import { JobModuleActionCompleted } from "@/modules/job-module/job-module-action-completed";
import { JobModuleActionFailed } from "@/modules/job-module/job-module-action-failed";
import { JobModuleActionRunning } from "@/modules/job-module/job-module-action-running";
import {
  ModelDeleteAsyncActionFailed,
  ModelDeleteAsyncActionSuccess,
} from "@/modules/model-delete-async";
import { ObservationActionCommented } from "@/modules/observation/observation-action-commented";

export const EventActionsHandler = () => {
  return (
    <>
      <JobModuleActionRunning />
      <JobModuleActionCompleted />
      <JobModuleActionFailed />
      <ObservationActionCommented />
      <ModelDeleteAsyncActionSuccess />
      <ModelDeleteAsyncActionFailed />
    </>
  );
};
